const plate_provices = [
  { id: '5', name: 'กาญจนบุรี', abbrv: 'กจ' },
  { id: '3', name: 'กรุงเทพมหานคร', abbrv: 'กท' },
  { id: '4', name: 'กระบี่', abbrv: 'กบ' },
  { id: '7', name: 'กำแพงเพชร', abbrv: 'กพ' },
  { id: '6', name: 'กาฬสินธุ์', abbrv: 'กส' },
  { id: '8', name: 'ขอนแก่น', abbrv: 'ขก' },
  { id: '9', name: 'จันทบุรี', abbrv: 'จบ' },
  { id: '10', name: 'ฉะเชิงเทรา', abbrv: 'ฉช' },
  { id: '12', name: 'ชัยนาท', abbrv: 'ชน' },
  { id: '11', name: 'ชลบุรี', abbrv: 'ชบ' },
  { id: '14', name: 'ชุมพร', abbrv: 'ชพ' },
  { id: '16', name: 'เชียงใหม่', abbrv: 'ชม' },
  { id: '13', name: 'ชัยภูมิ', abbrv: 'ชย' },
  { id: '15', name: 'เชียงราย', abbrv: 'ชร' },
  { id: '19', name: 'ตาก', abbrv: 'ตก' },
  { id: '17', name: 'ตรัง', abbrv: 'ตง' },
  { id: '18', name: 'ตราด', abbrv: 'ตร' },
  { id: '1', name: 'หนองคาย', abbrv: 'นค' },
  { id: '21', name: 'นครปฐม', abbrv: 'นฐ' },
  { id: '27', name: 'นราธิวาส', abbrv: 'นธ' },
  { id: '28', name: 'น่าน', abbrv: 'นน' },
  { id: '26', name: 'นนทบุรี', abbrv: 'นบ' },
  { id: '22', name: 'นครพนม', abbrv: 'นพ' },
  { id: '23', name: 'นครราชสีมา', abbrv: 'นม' },
  { id: '20', name: 'นครนายก', abbrv: 'นย' },
  { id: '25', name: 'นครสวรรค์', abbrv: 'นว' },
  { id: '24', name: 'นครศรีธรรมราช', abbrv: 'นศ' },
  { id: '29', name: 'บุรีรัมย์', abbrv: 'บร' },
  { id: '31', name: 'ประจวบคีรีขันธ์', abbrv: 'ปข' },
  { id: '32', name: 'ปราจีนบุรี', abbrv: 'ปจ' },
  { id: '30', name: 'ปทุมธานี', abbrv: 'ปท' },
  { id: '33', name: 'ปัตตานี', abbrv: 'ปน' },
  { id: '35', name: 'พังงา', abbrv: 'พง' },
  { id: '37', name: 'พิจิตร', abbrv: 'พจ' },
  { id: '36', name: 'พัทลุง', abbrv: 'พท' },
  { id: '34', name: 'พระนครศรีอยุธยา', abbrv: 'อย' },
  { id: '38', name: 'พิษณุโลก', abbrv: 'พล' },
  { id: '39', name: 'เพชรบุรี', abbrv: 'พบ' },
  { id: '40', name: 'เพชรบูรณ์', abbrv: 'พช' },
  { id: '41', name: 'แพร่', abbrv: 'พร' },
  { id: '42', name: 'ภูเก็ต', abbrv: 'ภก' },
  { id: '43', name: 'มหาสารคาม', abbrv: 'มค' },
  { id: '44', name: 'แม่ฮ่องสอน', abbrv: 'มส' },
  { id: '45', name: 'ยโสธร', abbrv: 'ยส' },
  { id: '46', name: 'ยะลา', abbrv: 'ยล' },
  { id: '47', name: 'ร้อยเอ็ด', abbrv: 'รอ' },
  { id: '48', name: 'ระนอง', abbrv: 'รน' },
  { id: '49', name: 'ระยอง', abbrv: 'รย' },
  { id: '50', name: 'ราชบุรี', abbrv: 'รบ' },
  { id: '51', name: 'ลพบุรี', abbrv: 'ลบ' },
  { id: '52', name: 'ลำปาง', abbrv: 'ลป' },
  { id: '53', name: 'ลำพูน', abbrv: 'ลพ' },
  { id: '54', name: 'เลย', abbrv: 'ลย' },
  { id: '55', name: 'ศรีสะเกษ', abbrv: 'ศก' },
  { id: '56', name: 'สกลนคร', abbrv: 'สน' },
  { id: '57', name: 'สงขลา', abbrv: 'สข' },
  { id: '58', name: 'สตูล', abbrv: 'สต' },
  { id: '59', name: 'สมุทรปราการ', abbrv: 'สป' },
  { id: '60', name: 'สมุทรสงคราม', abbrv: 'สส' },
  { id: '61', name: 'สมุทรสาคร', abbrv: 'สค' },
  { id: '62', name: 'สระบุรี', abbrv: 'สบ' },
  { id: '63', name: 'สิงห์บุรี', abbrv: 'สห' },
  { id: '64', name: 'สุโขทัย', abbrv: 'สท' },
  { id: '65', name: 'สุพรรณบุรี', abbrv: 'สพ' },
  { id: '66', name: 'สุราษฎร์ธานี', abbrv: 'สฎ' },
  { id: '67', name: 'สุรินทร์', abbrv: 'สร' },
  { id: '68', name: 'อ่างทอง', abbrv: 'อท' },
  { id: '69', name: 'อุดรธานี', abbrv: 'อด' },
  { id: '70', name: 'อุตรดิตถ์', abbrv: 'อต' },
  { id: '71', name: 'อุทัยธานี', abbrv: 'อน' },
  { id: '72', name: 'อุบลราชธานี', abbrv: 'อบ' },
  { id: '73', name: 'พะเยา', abbrv: 'พย' },
  { id: '74', name: 'มุกดาหาร', abbrv: 'มห' },
  { id: '75', name: 'สระแก้ว', abbrv: 'สก' },
  { id: '76', name: 'อำนาจเจริญ', abbrv: 'อจ' },
  { id: '77', name: 'หนองบัวลำภู', abbrv: 'นภ' },
  { id: '78', name: 'บึงกาฬ', abbrv: 'บก' }
];
export default plate_provices;
